import { createFileRoute, notFound } from "@tanstack/react-router";
import { productHubSlugs } from "@/lib/productHubConfig";
import ProductHubList from "@/pages/ProductHubList";
import NotFound from "@/pages/NotFound";

const SlugBuyingGuides = () => {
  const { slug } = Route.useParams();
  if (productHubSlugs.includes(slug)) return <ProductHubList hubSlug={slug} variant="buying-guides" />;
  return <NotFound />;
};

export const Route = createFileRoute("/$slug/buying-guides")({
  beforeLoad: ({ params }) => {
    if (!productHubSlugs.includes(params.slug)) throw notFound();
  },
  component: SlugBuyingGuides,
});
